import { Build } from '@stencil/core';
import mitt from 'mitt';

const ListingActionEvents = [
  'makeoffer.openmodal',
  'makeoffer.submit.success',
  'makeoffer.submit.failed',
  'TrackingEvent',
  'fraud.check.complete',
  'uds:calcPencilingDataUpdate:updated'
] as const;

type eventNameType = typeof ListingActionEvents[number];

globalThis.caiEventBus ||= mitt();
if (Build.isDev) {ListingActionEvents.forEach(eventName => {
    globalThis.caiEventBus.on(eventName, (data) => {
      console.log(eventName + ' | ', data);
    });
  });
}

const internalEvents = mitt();

export const emit = (eventName: eventNameType, payload?: object) => {
  globalThis.caiEventBus.emit(eventName, payload);
  return internalEvents.emit(eventName, payload);
};
export const emitEvent = emit;
export const off = internalEvents.off;
export const on = internalEvents.on;
export const once = (eventName: eventNameType, handler: EventListener) => {
  const wrapper = (payload) => {
    internalEvents.off(eventName, wrapper);
    handler(payload);
  };
  return internalEvents.on(eventName, wrapper);
};
